import { render, staticRenderFns } from "./info.vue?vue&type=template&id=52e90988&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=52e90988&lang=scss&scoped=true"
import style1 from "./info.vue?vue&type=style&index=1&id=52e90988&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e90988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e90988')) {
      api.createRecord('52e90988', component.options)
    } else {
      api.reload('52e90988', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=52e90988&scoped=true", function () {
      api.rerender('52e90988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/user/info.vue"
export default component.exports